	/* donation form */

	amount = null;

	function selectFormButton(button) {
		button = $(button);
		alreadySelected = button.hasClass('selected');
		$('.donation .radiobutton[data-radiogroup='+button.attr('data-radiogroup')+']').removeClass('selected');
		
		if(alreadySelected){
			button.removeClass('selected');
		} else {
			button.addClass('selected');
		}
		
		window.amount = $('.donation .radiobutton.selected').data('amount');
	}
	window.selectFormButton = selectFormButton;

	if($('.donation-container-wrapper')){
		donationStyle();
		$(window).on('resize', function(){
			donationStyle();
		});
	}

	function donationStyle() {
		
		if ($('.donation-container-wrapper').width() <= 512) {
			$('.donation-container-wrapper').find('.donation-container').css({'width': '90%'});
		}
		else if ($('.donation-container-wrapper').width() <= 767) {
			//$('.donation-container-wrapper').find('.donation-container').css({'width': '75%', 'max-width': '30rem'});
			$('.donation-container-wrapper').find('.donation-container').css({'width': '75%'});
		} else {
			$('.donation-container-wrapper').find('.donation-container').removeAttr('style');
		}
		
		
		if ($('.donation-container-wrapper').width() <= 767) {
			//$('.donation-container-wrapper').find('h2, .button-container').css({'width': '100%'});
		//	$('.donation .button-wrapper').css('width', '100%');
			if ($('.donation-container-wrapper').width() <= 400) {
				$('.donation-container-wrapper').find('input').css({'width': '4rem'});
				$('.donation-container-wrapper').find('.button, .radiobutton').css({'font-size': '1.5rem'});
				$('.donation-container-wrapper').find('.button, .radiobutton').css({'height': '3.5rem'});
			} else {
				$('.donation-container-wrapper').find('input').css({'width': '4.5rem'});
				$('.donation-container-wrapper').find('.button, .radiobutton').css({'font-size': '1.8rem'});
				$('.donation-container-wrapper').find('.button, .radiobutton').css({'height': 'inherit'});
			}
		}
		else {
			$('.donation-container-wrapper').find('h2, .button-container, .button-wrapper, .button, .radiobutton').removeAttr('style');
			$('.donation-container-wrapper').find('input').removeAttr('style');
		}
	}

	function customDonation(input) {
		input.value = input.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
		window.amount = input.value;
	}
	window.customDonation = customDonation;

	function submitDonation() {
		
		passivemember = ($("#passivemember").hasClass("selected") ? true : false );
		supporter = ($("#supporter").hasClass("selected") ? true : false );
		language = $("html").attr("lang").substring(0, 2);
		
		if (amount == null) {
			payrexxUrl = 'https://madamefrigo.payrexx.com/'+language+'/pay?cid=0f70b70d&hide_description=1&appview=1'
		} else {
			payrexxUrl = 'https://madamefrigo.payrexx.com/'+language+'/pay?cid=0f70b70d&donation[preselect_amount]='+amount+'&hide_description=1&appview=1'
		}
		
		jQuery("#popup-overlay").html('<div id="popup-content-centerer">\
			<div id="pop-up-form">\
					<div class="embed-container">\
						<iframe src="'+payrexxUrl+'" width="100%" height="800" style="border:0;" id="payrexx-embed" allow="payment *"></iframe>\
					</div>\
				</div>\
			</div>');
		jQuery("#popup-overlay").fadeIn();
		
/*		if (amount) {
			console.log("submitDonation triggered");
			// prepare data
			var data = {
				'action': 			'ajax_create_payrexx_gateway',
				'amount':			amount,
				'passivemember':	passivemember,
				'supporter':		supporter
			};

			// send
			$.post($('body').data('admin_url'), data, function(response) {

				console.log(response);
				
			//	$(".payrexx-modal-window").attr("data-href", response);
			//	jQuery(".payrexx-modal-window").payrexxModal();
				
				if(jQuery("#popup-overlay")){
					
				}
				
				jQuery("#popup-overlay").html('<div id="popup-content-centerer">\
					<div id="pop-up-form">\
							<div class="embed-container">\
								<iframe src=' + response + '></iframe>\
							</div>\
						</div>\
					</div>');
				jQuery("#popup-overlay").fadeIn();

			}, 'text');	
		}*/
	}
	window.submitDonation = submitDonation;


	function submitPatronage() {
		
		language = $("html").attr("lang").substring(0, 2);
		
		payrexxUrl = 'https://madamefrigo.payrexx.com/'+language+'/pay?cid=b8409296&donation[preselect_amount]=100&donation[preselect_interval]=annually&appview=1';
		
		jQuery("#popup-overlay").html('<div id="popup-content-centerer">\
			<div id="pop-up-form">\
					<div class="embed-container">\
						<iframe src="'+payrexxUrl+'" width="100%" height="800" style="border:0;" id="payrexx-embed" allow="payment *"></iframe>\
					</div>\
				</div>\
			</div>');
		jQuery("#popup-overlay").fadeIn();

	}
	window.submitPatronage = submitPatronage;

	
	$('.open-payrexx').on('click', function(event){
		console.log("open-payrexx triggered");
		if($(this).hasClass('button_type--donate')) {
			submitDonation();
		}
		if($(this).hasClass('button_type--patronage')) {
			submitPatronage();
		}
	});

	/* donation form */